import getClosest from '../utilities/get-closest';
import getAbsoluteHeight from '../utilities/get-absolute-height';
import debounce from '../utilities/debounce';

const lightbox = {

    instances: {},

    elements: {},

    activeModalElement: null,

    isPardotForm(src)
    {
        return src.indexOf('pardot') !== -1 || src.indexOf('insights.aimms.com') !== -1;
    },

    setupLightbox(element, id) 
    {
        // reference to this modal instance
        const instanceId = id.replace('#', '');

        // reference to the dom node
        const lightboxId = '#' + instanceId;

        // content container
        const contentElement = document.querySelector( lightboxId );

        // if there's no source HTML, exit
        if( !contentElement ) return;

        let tingleInstance = null;
        let iframe = null;

        const resizeLightbox = (e) => 
        {
            let tingleInstance = document.querySelector('.tingle-modal--visible');
            
            if( iframe && iframe.getAttribute('src') && this.isPardotForm(iframe.getAttribute('src')) )
            {
                // need to get the formId so we can attempt to match it with height information which can/will
                // have been posetd from the contained pardot form JS
                let formId = iframe.getAttribute('src').split('/').splice(-1)[0];

                // prune the ? 
                if( formId.indexOf('?') !== -1 )
                {
                    formId = formId.substring(0, formId.indexOf('?'));
                }

                if( formId && window.pardotFormLightboxInstances[formId] )
                {
                    const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream; 

                    const lightbox = tingleInstance.querySelector('.lightbox');

                    const lightboxHeader = tingleInstance.querySelector('h2');
                    
                    const lightboxHeight = Math.ceil(window.pardotFormLightboxInstances[formId].height) + 20;

                    const interiorMargin = 90;
                    
                    const windowHeight = (iOS) 
                        ? document.documentElement.offsetHeight 
                        : window.innerHeight;

                    const viewportSpace = windowHeight - interiorMargin;
                    
                    let lightboxHeaderHeight = (lightboxHeader)
                        ? getAbsoluteHeight(lightboxHeader)
                        : 0;

                    const desiredHeight = lightboxHeight + lightboxHeaderHeight + interiorMargin;
                        
                    let newHeight = Math.min(viewportSpace, desiredHeight);
                    
                    lightbox.style.height = newHeight + 'px';
                    lightbox.style.maxHeight = newHeight + 'px';
                }
            }
        }
        
        if( ! this.instances[instanceId] )
        {
            // instantiate new modal
            const modal = new tingle.modal({
                footer: true,
                stickyFooter: false,
                closeMethods: ['overlay', 'button', 'escape'],
                closeLabel: "Close",
                onOpen: (a, b) => {

                    // const close = document.querySelector(".tingle-modal__close");
                    // const modalContent = document.querySelector(".tingle-modal-box__content");
                    // const lightboxContainer = modalContent.firstElementChild;
                    // lightboxContainer.appendChild(close);
                    const closeButtons = document.querySelectorAll('.tingle-modal__close');

                    tingleInstance = document.querySelector('.tingle-modal');
                    // iframe = tingleInstance.querySelector('iframe');

                    iframe = modal.modal.querySelector('iframe');

                    if( iframe.getAttribute('data-src') )
                    {
                        iframe.src = iframe.getAttribute('data-src');
                    }

                    Array.prototype.forEach.call( closeButtons, function(button) {
                        if( ! button.parentNode.classList.contains('lightbox') )
                        {
                            const container = button.parentNode.querySelector('.lightbox');
                            
                            container.appendChild(button);

                            const modalContainer = getClosest( button, '.tingle-modal');
                            
                            if( modalContainer )
                            {
                                modalContainer.addEventListener('click', e => {
                                    const lightboxContainer = getClosest( e.target, '.lightbox' );
                                    if( !lightboxContainer )
                                    {
                                        modal.close();
                                    }
                                });
                            }
                        }
                    });

                    // handle a resize which originates from a post ping from the nested document
                    const debouncedResizeLightbox = debounce((e) => resizeLightbox(e), 500);
                    window.addEventListener('onPardotFormHeightUpdated', debouncedResizeLightbox, true);

                    // handle a resize from this Aimms page
                    window.addEventListener('resize', resizeLightbox, true);

                    // resize immediately
                    resizeLightbox();

                    // again? 
                    setTimeout( function(){
                        resizeLightbox();
                    }, 500)
                },
                onClose: () => {
                    window.removeEventListener('onPardotFormHeightUpdated', resizeLightbox, true);
                    window.removeEventListener('resize', resizeLightbox, true);
                }
            });

            // set content
            modal.setContent(contentElement.innerHTML);

            this.instances[instanceId] = {
                instanceId: instanceId,
                lightboxId: lightboxId,
                modal: modal
            };
        }

        element.addEventListener('click', (e) => {
            e.stopPropagation();
            e.preventDefault();
            this.instances[instanceId].modal.open();
        });
        
        if( window.location.hash )
        {
            const hash = window.location.hash;
            if( hash.indexOf('pardot-form-id=' + instanceId) !== -1 )
            {
                this.instances[instanceId].modal.open();
            }
        }
    },

    cacheDom()
    {
        this.elements.lightboxes = document.querySelectorAll('.js-lightbox, [href*="pardot-form-id="], [href*="#demo-form"]');
    },

    bind()
    {
        if( this.elements.lightboxes )
        {
            Array.prototype.forEach.call( this.elements.lightboxes, (element) => {

                // on elements which were WP-controlled, and a data-lightbox attribute was added
                if( element.getAttribute('data-lightbox') )
                {
                    this.setupLightbox(element, element.getAttribute('data-lightbox'));
                }

                // on elements which were created by an admin by adding links in a wysiwyg, with a URL pattern like: #pardot-form-id=my-pardot-form
                else if( element.getAttribute('href') )
                {
                    const href = element.getAttribute('href');

                    if( href.indexOf('#demo-form') !== -1 )
                    {
                        this.setupLightbox(element, 'demo-form');
                    }
                    else
                    {
                        var formIdParts = href.match(/pardot-form-id=([a-zA-Z\-_]+)/);
                        
                        if( formIdParts.length && formIdParts[1] )
                        {
                            this.setupLightbox(element, formIdParts[1]);
                        }
                    }
                }
            });
        }
    },

    init() {
        this.cacheDom();
        this.bind();
    }
}

export default lightbox;